export default {
    headerDesktopLibre: '1',
};
